import { inject, Injectable } from "@angular/core";
import { CookieConsent } from "src/app/_core/state/dialogs/cookies/service/models/cookie-consent";
import { ConfigService } from "src/app/services/config.service";
import { LocaleService } from "src/app/services/locale.service";

const COOKIE_CONSENT_KEY = 'cookie-consent';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {

  private readonly localeService = inject(LocaleService);
  private readonly configService = inject(ConfigService);

  hasCookies(): boolean {
    return !!localStorage.getItem(COOKIE_CONSENT_KEY);
  }

  setCookiesLocalStorage(cookies: CookieConsent[]) {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(cookies));
  }

  hasConsentForCookie(cookieId: string): boolean {
    const cookies = this.getCookies();
    return cookies.find((c) => c.id === cookieId)?.accepted;
  }

  getCookies(): CookieConsent[] {
    const cookiesStored = localStorage.getItem(COOKIE_CONSENT_KEY);
    const lang = this.localeService.getLanguage();

    if (cookiesStored) {
      return JSON.parse(cookiesStored);
    }

    return [
      { id: 'aws', required: true, accepted: true, show: true, title: 'cookies.aws.title', description: 'cookies.aws.description' },
      { id: 'session', required: true, accepted: true, show: true, title: 'cookies.session.title', description: 'cookies.session.description' },
      { id: 'ga', required: false, accepted: false, show: true, title: 'cookies.ga.title', description: 'cookies.ga.description' },
      { id: 'heap', required: false, accepted: false, show: lang !== 'nl', title: 'cookies.heap.title', description: 'cookies.heap.description' },
      { id: 'zendesk', required: false, accepted: false, show: true, title: 'cookies.zendesk.title', description: 'cookies.zendesk.description' },
      { id: 'clarity', required: false, accepted: false, show: this.hasGTM(), title: 'cookies.clarity.title', description: 'cookies.clarity.description' },
    ];
  }

  private hasGTM() {
    return !!this.configService.get()?.googleTagManagerId;
  }
}
